const Logo = () => (
  <img 
    src="/logo.png" 
    alt="CtrlAltComplete" 
    className="w-10 h-10"
  />
);

export default Logo;
